<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent sp-margin__bottom-x2">
      {{ 'COMPANIES.SETTINGS_CTA' | translate }}
    </h3>
    <form [formGroup]="company_settings_form_group">
      <mat-slide-toggle
        class="sp-margin__bottom-x4"
        formControlName="is_store_payment_method_enabled">
        <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.ENABLE_STORE_PM_LABEL' | translate }}</p>
      </mat-slide-toggle>
      <mat-slide-toggle
        class="sp-margin__bottom-x4"
        formControlName="is_iban_refund_enabled">
        <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.ENABLE_VBAN_REFUND' | translate }}</p>
      </mat-slide-toggle>
      <mat-slide-toggle
        class="sp-margin__bottom-x4"
        formControlName="is_ext_order_id_enabled">
        <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.ENABLE_EXT_ORDER_ID_LABEL' | translate }}</p>
      </mat-slide-toggle>

      <div class="sp-margin__bottom-x2">
        <mat-slide-toggle
          class="sp-margin__bottom-x2"
          formControlName="is_tax_deduction_enabled">
          <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.ENABLE_TAX_DEDUCTION_LABEL' | translate }}</p>
        </mat-slide-toggle>

        <p
          *ngIf="isTaxDeductionDependencyError()"
          class="sp-color__warn sp-text__s">
          {{ 'COMPANIES.TAX_DEDUCTION_REQUIREMENTS_WARNING' | translate }}
        </p>
      </div>

      <mat-form-field
        *ngIf="isTaxDeductionEnabled()"
        class="sp-width__full sp-margin__bottom-x4"
        appearance="fill"
        color="accent">
        <mat-label>{{ 'COMPANIES.TAX_DEDUCTION_LABEL' | translate }}</mat-label>
        <mat-select
          formControlName="tax_deduction_type"
          multiple>
          <mat-option [value]="allowed_deduction_types.bonus_mobili">{{
            'COMPANIES.TAX_DEDUCTION_BM_LABEL' | translate
          }}</mat-option>
          <mat-option [value]="allowed_deduction_types.conto_termico_3">{{
            'COMPANIES.TAX_DEDUCTION_TC_LABEL' | translate
          }}</mat-option>
          <mat-option [value]="allowed_deduction_types.interventi_sismici">{{
            'COMPANIES.TAX_DEDUCTION_IS_LABEL' | translate
          }}</mat-option>
          <mat-option [value]="allowed_deduction_types.riqualifica_edilizia">{{
            'COMPANIES.TAX_DEDUCTION_RE_LABEL' | translate
          }}</mat-option>
          <mat-option [value]="allowed_deduction_types.risparmio_energetico">{{
            'COMPANIES.TAX_DEDUCTION_RS_LABEL' | translate
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-slide-toggle
        class="sp-margin__bottom-x4"
        formControlName="is_tax_date_and_number_enabled">
        <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.ENABLE_TAX_DATE_AND_NUMBER_LABEL' | translate }}</p>
      </mat-slide-toggle>

      <!--<mat-slide-toggle
        class="sp-margin__bottom-x4"
        formControlName="is_custom_domains_enabled">
        <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.ENABLE_COMPANY_DOMAINS_LABEL' | translate }}</p>
      </mat-slide-toggle>-->

      <div class="sp-margin__bottom-x4">
        <p class="sp-color__accent sp-margin__bottom-x2">
          {{ 'COMPANIES.ONBOARDING_MANAGEMENT_LABEL' | translate }}
        </p>

        <mat-slide-toggle
          class="sp-margin__bottom-x2"
          formControlName="is_fourthline_onboarding_enabled">
          <p class="sp-color__primary sp-margin__left">
            {{ 'COMPANIES.ENABLE_FOURTHLINE_ONBOARDING_LABEL' | translate }}
          </p>
        </mat-slide-toggle>
      </div>

      <div class="sp-margin__bottom-x4">
        <p class="sp-color__accent sp-margin__bottom-x2">
          {{ 'COMPANIES.PREPAID_CARDS_MANAGEMENT_LABEL' | translate }}
        </p>

        <mat-slide-toggle
          class="sp-margin__bottom-x2"
          formControlName="is_prepaid_cards_blocked"
          (change)="onPrepaidBlockToggle()">
          <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.BLOCK_PREPAID_CARD' | translate }}</p>
        </mat-slide-toggle>

        <mat-slide-toggle
          class="sp-margin__bottom-x2"
          formControlName="is_prepaid_cards_blocked_on_long"
          [disabled]="isPrepaidBlockEnabled()">
          <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.BLOCK_PREPAID_CARD_ON_LONG' | translate }}</p>
        </mat-slide-toggle>

        <mat-slide-toggle
          class="sp-margin__bottom-x2"
          formControlName="is_prepaid_cards_blocked_on_ecommerce"
          [disabled]="isPrepaidBlockEnabled()">
          <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.BLOCK_PREPAID_CARD_ON_ECOMMERCE' | translate }}</p>
        </mat-slide-toggle>
      </div>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="is_company_edit_running || isSelectedDeductionTypesEmpty() || isTaxDeductionDependencyError()"
        [is_spinner_visible]="is_company_edit_running"
        (button_click)="onConfirmClick()"></app-shared-button>
    </form>
  </div>
</div>
